import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { tag } from '@helpers/typography';
import { imageWrapperPreserveRatio, imageCoverContainer } from '@helpers/image';
import SimpleImage from '@stories/Components/SimpleImage/SimpleImage';
import styled from 'styled-components';
const Container = styled.article `
  display: block;

  &:not(:last-child) {
    padding-bottom: 24px;
    border-bottom: 1px solid ${brand.grey.otherGrey};
    margin-bottom: 24px;
  }

  @media ${from(Device.DesktopLarge)} {
    &:not(:last-child) {
      padding-bottom: 48px;
      border-bottom: 1px solid ${brand.grey.otherGrey};
      margin-bottom: 48px;
    }
  }
`;
const Link = styled.a `
  display: grid;
  align-items: center;
  gap: 12px;
  grid-template-columns: min(50%, 135px) 1fr;
  text-decoration: none;

  @media ${from(Device.Tablet)} {
    grid-template-columns: min(50%, 185px) 1fr;
  }

  @media ${from(Device.DesktopLarge)} {
    gap: 32px;
  }
`;
const ImageWrapper = styled.div `
  ${imageWrapperPreserveRatio(185, 134)}
`;
const Image = styled(SimpleImage) `
  ${imageCoverContainer()}
`;
const ContentWrapper = styled.div `
  display: block;
`;
const Tag = styled.small `
  ${tag};
  display: block;
  color: ${brand.grey.otherGrey};
  margin: 0 0 12px;
`;
const Title = styled.h3 `
  display: block;
  color: ${brand.white};
  ${fonts.heading.bold};
  font-size: 16px;
  letter-spacing: -0.01em;
  line-height: 24px;
  text-decoration: none;
  text-underline-position: under;

  @media ${from(Device.DesktopLarge)} {
    font-size: 18px;
    line-height: 30px;
  }

  ${Link}:focus &,
  ${Link}:hover & {
    text-decoration: underline;
  }
`;
const ArticleSummaryStyles = {
    Container,
    ContentWrapper,
    ImageWrapper,
    Image,
    Link,
    Tag,
    Title,
};
export default ArticleSummaryStyles;
